import { render, staticRenderFns } from "./MemberAliPay.vue?vue&type=template&id=4d152a3e&scoped=true"
import script from "./MemberAliPay.vue?vue&type=script&lang=js"
export * from "./MemberAliPay.vue?vue&type=script&lang=js"
import style0 from "./MemberAliPay.vue?vue&type=style&index=0&id=4d152a3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d152a3e",
  null
  
)

export default component.exports